import { Log, apiRequest } from '@ext/utils'; import { Paginacion } from '@ext/env';
export * from './Diaria.types'
import { IEstadisticaDiaria } from './Diaria.lib';

export class EstadisticaDiaria extends IEstadisticaDiaria {

 

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<EstadisticaDiaria>; Error?: boolean; }> {

        let a: Array<EstadisticaDiaria> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/estadisticas/diaria` );
        request.params = params;
        if ( await request.get() ) {
            if ( request.data.response ) {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results ) {
                for ( let i of request.data.results ) {
                    let p = new EstadisticaDiaria( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

  
}